import React from "react";
import Rectangle from "./shapes/Rectangle";
import "./Divider.css";

const Divider = () => {
  const colorPalette = [
    "#FD015F",
    "#FFFFFF",
    "#0C82DC",
    "#FFFFFF",
    "#FFFFFF",
    "#FFBD39",
    "#FFFFFF",
    "#3DD695",
    "#3DD695",
    "#FFFFFF",
    "#3DD695",
    "#FFFFFF",
    "#FFFFFF",
    "#FD015F",
    "#FFFFFF",
    "#FFBD39",
    "#0C82DC",
    "#FFFFFF",
    "#FFBD39",
    "#FFFFFF",
    "#FFFFFF",
    "#0C82DC",
    "#FFFFFF",
    "#FD015F",
  ];

  return (
    <div className="flex flex-wrap pt-48 pb-10 max-md:pt-25 max-sm:pt-20">
      {colorPalette.map((color, index) => (
        <Rectangle
          key={index}
          colors={{ default: color }}
          size={{ width: "25%" }}
          className="rectangle"
        />
      ))}
    </div>
  );
};

export default Divider;
